export var HousingStatusList;
(function (HousingStatusList) {
    HousingStatusList["Renting"] = "Renting";
    HousingStatusList["Boarding"] = "Boarding";
    HousingStatusList["Caravan"] = "Caravan";
    HousingStatusList["Other"] = "Other";
    HousingStatusList["OwnHome"] = "Own Home";
    HousingStatusList["OwnHomeMortgage"] = "Own Home Mortgage";
    HousingStatusList["SuppliedByEmployer"] = "Supplied by Employer";
    HousingStatusList["WithParents"] = "With Parents";
})(HousingStatusList || (HousingStatusList = {}));
//# sourceMappingURL=HousingStatusList.js.map